module.exports = __webpack_public_path__ + "img/PUSH.3c064464.svg";